module.exports = __webpack_public_path__ + "img/icon38.2257cb79.png";